import React, { useState, useMemo } from "react";

const LINE_PREFIX = /^[\s\-\*\+\u2022\u2023\u25E6\u2043\u2219]*(?:\d+[.)]\s*)?(?:\[.?\]\s*)?/;

function countItems(text: string): number {
  return text
    .split(/\n/)
    .map((l) => l.replace(LINE_PREFIX, "").trim())
    .filter(Boolean).length;
}

interface Props {
  onSubmit: (text: string) => void;
  loading: boolean;
}

export function BulkInput({ onSubmit, loading }: Props) {
  const [text, setText] = useState("");
  const itemCount = useMemo(() => countItems(text), [text]);

  return (
    <div className="mt-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700" />
        <span className="text-sm text-gray-400 dark:text-gray-500">ou cole uma lista</span>
        <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700" />
      </div>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={`- guardanapo de papel\n- suco integral de uva\n- leite sem lactose\n- queijo minas frescal\n- tomate\n- po de cafe`}
        className="w-full h-40 p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-400 dark:placeholder:text-gray-500"
        disabled={loading}
      />

      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-gray-400 dark:text-gray-500">
          {itemCount > 0 ? `${itemCount} ${itemCount === 1 ? "item" : "itens"} detectados` : ""}
        </span>
        <button
          onClick={() => onSubmit(text)}
          disabled={loading || itemCount === 0}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
        >
          {loading ? `Buscando ${itemCount} itens...` : "Buscar lista"}
        </button>
      </div>

      {loading && (
        <div className="mt-3 h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div className="h-full bg-blue-500 dark:bg-blue-400 rounded-full animate-pulse w-2/3" />
        </div>
      )}
    </div>
  );
}
